import React, { useState, forwardRef, useImperativeHandle } from 'react';
import { Modal, Container, Row, Col } from 'react-bootstrap'
import { FaNotesMedical, FaDoorOpen } from "react-icons/fa";
import { EntranceDiv, ActiveButton } from './styled/buttonlinkstyled';
import example from './img/mask_example.png';
import example2 from './img/mask_example2.png';
import example3 from './img/map_info.PNG';

const EntranceLink = forwardRef(({ refEntrance }) => {
    // EntranceLink開關設定
    const [entrance, setEntrance] = useState(false);

    const exampleimage = {
        width: `100%`
    }

    // EntranceLink開關function
    function startOpen() {
        setEntrance(true);
    };

    // refEntrance與map.jsx的 const refEntrance = useRef(null); 相互連結
    useImperativeHandle(refEntrance, () => {
        return {
            startOpen: startOpen
        };
    });

    // EntranceLink開關function
    function entranceClick() {
        setEntrance(!entrance)
    }

    return (
        <>
            {/* 這是EntranceLink開關按鈕 */}
            <EntranceDiv entrance={entrance} onClick={entranceClick}>
                <FaNotesMedical />
            </EntranceDiv>

            {/* 這是EntranceLink的內容Modal */}
            <Modal
                show={entrance}
                onHide={entranceClick}
                size="lg"
            >
                <Modal.Header closeButton>
                    <Modal.Title className='useTitle textJhengHei'>找口罩地圖─查詢須知及說明</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Container className='textJhengHei'>
                        <Row>
                            <Col sm={5}><img className='useImage' style={{ exampleimage }} src={example} alt='' /></Col>
                            <Col sm={7}>
                                <div className='useArticle'><p>口罩數量的顏色意義：</p></div>
                                <ul className='useList '>
                                    <li className='green'>綠色狀態：口罩存量超過1000件，供貨正常</li>
                                    <li className='orange'>橘色狀態：口罩存量在1000件以下、未低於100，供貨尚可</li>
                                    <li className='brown'>棕色狀態：口罩存量低於100件以下，供貨吃緊</li>
                                    <li className='red'>紅色狀態：口罩已完售，補貨中</li>
                                </ul>
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={5}><img className='useImage' style={{ exampleimage }} src={example2} alt='' /></Col>
                            <Col sm={7}>
                                <div className='useArticle'><p>口罩狀態：</p></div>
                                <ul className='useList '>
                                    <li>當目標口罩呈現局部半透明狀態，表示該店口罩存量低於100件以下，請自行判斷是否繼續前往或改前往其他店家購買。</li>
                                </ul>
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={12}>
                                <div className='useArticle'><p>介面操作：</p></div>
                                <img className='useImage' style={{ exampleimage }} src={example3} alt='' />
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={12}>
                                <br />
                                <div className='useArticle '><p>選單功能：</p></div>
                                <ul className='useList'>
                                    <li>我的位置：直接定位至使用者手機坐標並顯示圖像。</li>
                                    <li>最近大人口罩：直接定位至有大人口罩庫存及最近商家位置。</li>
                                    <li>最近幼兒口罩：直接定位至有幼兒口罩庫存及最近商家位置。</li>
                                    <li>口罩供需資訊平台。</li>
                                    <li>1922防疫達人。</li>
                                    <li>武漢肺炎相關資訊。</li>
                                </ul>
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={12}>
                                <br />
                                <div className='useArticle '><p>使用須知： </p></div>
                                <ul className='useList'>
                                    <li>部分藥局因採發放號碼牌方式，方便民眾購買口罩，系統目前無法顯示已發送號碼牌數量。</li>
                                    <li>口罩數量以藥局實際存量為主，線上查詢之數量僅供參考。</li>
                                    <li>若您的藥局有需要加註的公告事項，可以填寫表單：<a href='https://pse.is/KH7DC' alt=''>https://pse.is/KH7DC</a></li>
                                    <li>填寫的資料會不定期匯出到<a href='https://pse.is/QDSMW' alt=''>https://pse.is/QDSMW</a></li>
                                    <li>手機使用前請開啟定位服務。</li>
                                </ul>
                            </Col>
                        </Row>
                    </Container>
                </Modal.Body>
                <Modal.Footer>
                    <ActiveButton
                        onClick={entranceClick}
                    ><FaDoorOpen />離開
                    </ActiveButton>
                </Modal.Footer>
            </Modal>
        </>
    )
});

export default EntranceLink;